import { render, staticRenderFns } from "./SponsorPage.vue?vue&type=template&id=90586f08&scoped=true"
import script from "./SponsorPage.vue?vue&type=script&lang=js"
export * from "./SponsorPage.vue?vue&type=script&lang=js"
import style0 from "./SponsorPage.vue?vue&type=style&index=0&id=90586f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90586f08",
  null
  
)

export default component.exports